/* Omah Lempung: WhatsApp checkout.
   - Product page "Order via WhatsApp" uses the same order format as the cart.
   - Safety net: any leftover Shopify checkout button sends people back to the cart. */
(function () {
  'use strict';

  function patchProduct() {
    var C = customElements.get('ol-product');
    if (!C || C.prototype.__olWa) return;
    C.prototype.__olWa = true;
    C.prototype.updateWa = function () {
      if (!this.wa || !this.data) return;
      var v = this.current;
      var qty = this.qtyInput ? (parseInt(this.qtyInput.value, 10) || 1) : 1;
      var link = String(this.data.url || '').replace(/^https?:\/\//, '');
      var lines = ['Hello Omah Lempung,', '', '*Product:* ' + this.data.title];
      if (v && !this.data.single) lines.push('*Variant:* ' + v.title);
      lines.push('*Quantity:* ' + qty);
      lines.push('*Link:* ' + link);
      this.wa.href = this.data.wa_base + '?text=' + encodeURIComponent(lines.join('\n'));
    };
    Array.prototype.forEach.call(document.querySelectorAll('ol-product'), function (p) { p.updateWa(); });
  }

  if (window.customElements) customElements.whenDefined('ol-product').then(patchProduct);

  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (s && s.name === 'checkout') {
      e.preventDefault();
      window.location.href = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
    }
  }, true);
})();
